
// src/connects/division-settings-page.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import uploadFiles from '../helpers/file-upload'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import componentId from '../helpers/component-id'
import combineHOC from '../helpers/combine-hoc'
import { trackPage, trackHandlers } from '../helpers/analytics'
import { validate } from '../helpers/form-validator'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'
import find from 'lodash/find'
export const mapStateToProps = (state, ownProps)=> {
  const division = getArray('division_id', state.divisions.items, state.divisions.currentId) || {}
  return {
    isPhone: state.media.isPhone,
    division: division,
    _uploadFile: state.uploadFile[ownProps.componentId],
    isUpdating: state.divisionSettings.isUpdating,
    isUpdateFailed: state.divisionSettings.isUpdateFailed,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    onClose: ()=> dispatch(actions.closeDivisionSettingsPage()),
    validateAndSubmit: (props, crop, event = undefined) => {
      if (event && event.preventDefault)
        event.preventDefault();

      validate(props.ui, {
        name: { rule: 'isRequired' },
      }, (errors, nextUI) => {
        props.updateUI(nextUI)

        if (errors) {
          return
        }

        if (props.division) {
          dispatch(actions.updateDivision(
            props.division.division_id,
            props.ui.name,
            props.ui.access_type,
            props.uploadedFile && props.uploadedFile.file_id,
            crop
          ))
        }
      })
      return false
    },
    uploadFile: (props, file)=> !props.isUploading && uploadFiles(
      file, dispatch, props.division.division_id, 'division',
      ownProps.componentId, true
    ),
    willUpdate: (props, nextProps)=> {
      // changing isFetching true => false
      if (props.isUpdating && !nextProps.isUpdating) {
        if (!nextProps.isUpdateFailed) { // successfully updated
          dispatch(emitAlertMessage("label:Section preferences have been updated", "success"))
        }
      }
    },
    willMount: (props)=> {
    },

    willUnmount: ()=> {
    },
  }
}


export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  var uploadFile
  if (stateProps._uploadFile) {
    uploadFile = find(stateProps._uploadFile, (value, key)=> value)
  }

  return {
    isUploading: uploadFile && uploadFile.isUploading,
    uploadedFile: uploadFile && uploadFile.item,
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    isUpdating: stateProps.isUpdating,
    isUpdateFailed: stateProps.isUpdateFailed
  }
}

export default combineHOC(
  componentId,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({
    state: {
      active: false,
      name: (props)=> props.division.name ? props.division.name : '',
      access_type: (props)=> props.division.is_private ? 'private_access'  : 'public_access',
      params: undefined,
      nameError: undefined,
      handlers: undefined,
    },
    exports: true,
  }),
  lifecycle,
  translate(),
  trackPage('division_profile'),
  trackHandlers('validateAndSubmit', 'group_form_submit'),
)



// WEBPACK FOOTER //
// ./src/connects/division-baisc-settings-page.js